/**
 * Exception messages we own and are stable to target
 */
export const TOO_MANY_SEND_ATTEMPTS = 'Max send attempts reached'
export const TOO_MANY_CHECK_ATTEMPTS = 'Max check attempts reached'
export const NO_VALID_EMAIL = 'Member Email must be a valid email address'
export const NO_VALID_SMS_PHONE =
  'Member must have at least one primary sms capable number'
export const NO_VALID_PRIMARY_PHONE =
  'Member must have at least one primary number'
export const INVALID_MFA_CODE = 'Invalid MFA code'
